// §4.4 partial — admin/system routes.
// Composer auto-collects this into routes.generated.ts.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";
import { AdminLayout } from "../_layout/AdminLayout";

const AlertsPage = lazyWithRetry(() => import("./pages/AlertsPage"));
const HistoryPage = lazyWithRetry(() => import("./pages/HistoryPage"));
const StatsPage = lazyWithRetry(() => import("./pages/StatsPage"));
const SystemPage = lazyWithRetry(() => import("./pages/SystemPage"));

const routes: RouteObject[] = [
  {
    Component: AdminLayout,
    children: [
      { path: "/admin/system", Component: SystemPage },
      { path: "/admin/system/status", Component: SystemPage },
      { path: "/admin/system/history", Component: HistoryPage },
      { path: "/admin/system/alerts", Component: AlertsPage },
      { path: "/admin/system/stats", Component: StatsPage },
    ],
  },
];

export default routes;
